<template>
  <div class="home-banner-wrapper">
    <img v-lazy="activityBannerDesc.banner" class="img-banner" />
    <div class="activity-detail-btn" @click="handleShowActivityDetail">活<br />动<br />详<br />情</div>
    <div class="btn-wrapper">
      <div class="btn btn btn-detail" @click="handleJumpPage('contribute')" v-if="contributeStatus">
        报名入口
      </div>
      <div class="btn btn-my-work" @click="handleJumpPage('myWork')">我的申报</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  name: "uiHomeBanner",
  methods: {
    ...mapMutations({
      setUnShowHead: "userInfo/setUnShowHead",
      setNextRouteName: "userInfo/setNextRouteName",
      showOpenApp: "showOpenApp"
    }),
    ...mapActions({
      getUserInfoBindPhone: "userInfo/getUserInfoBindPhone",
      getUserDetail: "userInfo/getUserDetail"
    }),
    async handleJumpPage(routeName) {
      const isNfPlus = this.systemInfo.isNfPlus
      if (!isNfPlus) {
        this.showOpenApp("请打开南方+报名或查看我的申报")
        return
      } else {
        const hasUserInfo = await this.getUserInfoBindPhone()
        if (!hasUserInfo) return
        if (routeName === "contribute") {
          this.handleJumpContribute(routeName)
          return
        }
        hasUserInfo && this.$router.push({ name: routeName })
      }
    },
    async handleJumpContribute(routeName) {
      let hasPerfectedUserInfo = this.hasPerfectedUserInfo
      if (!hasPerfectedUserInfo) {
        await this.getUserDetail()
        hasPerfectedUserInfo = this.hasPerfectedUserInfo
      }
      if (hasPerfectedUserInfo) {
        this.$router.push({ name: routeName })
      } else {
        this.setNextRouteName("contribute")
        this.setUnShowHead(true)
        this.$router.push({ name: "userInfo" })
      }
    },
    handleShowActivityDetail() {
      this.$emit("showActivityDetail", true)
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo",
      hasPerfectedUserInfo: "userInfo/hasPerfectedUserInfo",
      userUuid: "userInfo/userUuid",
      activityBannerDesc: "activityInfo/activityBannerDesc",
      contributeStatus: "activityInfo/contributeStatus"
    })
  }
}
</script>

<style lang="scss" scoped>
.home-banner-wrapper {
  width: 100%;
  height: 4rem;
  margin-bottom: -0.35rem;
  padding-top: 2.74rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-banner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 1;
  }
  .activity-detail-btn {
    position: absolute;
    right: 0;
    top: 1.06rem;
    font-size: 0.26rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0.225rem 0 0 0.225rem;
    z-index: 1;
    padding: 0.14rem 0.16rem;
    color: #ffffff;
    line-height: 1.1;
  }
  .btn-wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    .btn {
      background: linear-gradient(to right, #ff3434, #ff6029);
      width: 1.7rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      overflow: hidden;
      box-shadow: 0 0.04rem 0.08rem rgba(0, 0, 0, 0.5);
      font-family: PingFangSC-Semibold;
      font-size: 0.28rem;
      color: #ffffff;
      text-align: center;
      margin-right: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0;
      &.btn-contribute {
        width: 2.2rem;
        height: 0.7rem;
        border-radius: 0.35rem;
      }
      .icon-fire {
        background: url("../../../assets/images/icon_hot.png") no-repeat center;
        width: 0.28rem;
        height: 0.32rem;
        background-size: 100%;
        margin-right: 0.06rem;
      }
      .icon-light {
        background: url("../../../assets/images/light.png") no-repeat center;
        width: 1.64rem;
        height: 0.7rem;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        opacity: 1;
        animation: lightAnimation 3s linear 0s infinite;
        transform: translateX(-100%);
      }
      &:last-child {
        margin-right: 0;
      }
      &:active {
        opacity: 0.7;
      }
    }
  }
}

@keyframes lightAnimation {
  0% {
    left: 0rem;
  }
  100% {
    left: 10rem;
  }
}
</style>
